import React, { useState, useEffect } from 'react';
import { Accordion } from 'react-bootstrap';
import { connect } from 'react-redux';
import Item from './section-fqs-item';
import { useParams } from 'react-router-dom';
import { SectionPlayVideos, Footer } from '../../components';
import {
  fetchFaqsServicios,
  fetchFaqsProblems,
  fetchFaqsInstructions,
  fetchFaqsSecurity
} from '../../redux/actions/apiAction';

import classes from './faqspage.module.css';

import './faqs-list.css'
import MainLayout from '../../layouts/main-layout/main-layout';

const SectionFqsGeneral = ({
  faqs_service,
  fetchFaqsServicios,
  faqs_problems,
  fetchFaqsProblems,
  faqs_instructions,
  fetchFaqsInstructions,
  faqs_security,
  fetchFaqsSecurity
}) => {
  let { hide } = useParams();
  const [sizeVideo, setSizeVideo] = useState('short');

  const showAllVideos = () => {
    setSizeVideo(sizeVideo === 'short' ? 'large' : 'short');
  }

  useEffect(() => {
    fetchFaqsServicios();
    // fetchFaqsProblems();
    // fetchFaqsInstructions();
    // fetchFaqsSecurity();

  }, [fetchFaqsServicios]);
  return (
    <>
    {
      !hide &&
      <MainLayout />
    }
      
      <div className={classes.contentFaqs}>
        <SectionPlayVideos
          size={sizeVideo}
          scope="faqs"
          onClickBtnShow={showAllVideos}
        />

        <div className={classes.contentTitle}>
          <h1 className="main-text slide-title">Dudas frecuentes</h1>
        </div>

        <div className={classes.contentAccordion}>
          <div>
            <Accordion defaultActiveKey={1}>
              {
                faqs_service && faqs_service.length ?
                  faqs_service.map((item, index) => {
                    return <Item data={item} key={index} />
                  })
                  : ''
              }
            </Accordion>
          </div>

          {/* <div>
          <h3 className={classes.subtitleSection}>Aclaraciones</h3>
          <Accordion defaultActiveKey={1}>
            {
              faqs_problems && faqs_problems.length ?
                faqs_problems.map((item, index) => {
                  return <Item data={item} key={index} />
                })
                : ''
            }
          </Accordion>
        </div>
        <div>
          <h3 className={classes.subtitleSection}>Instrucciones</h3>
          <Accordion defaultActiveKey={1}>
            {
              faqs_instructions && faqs_instructions.length ?
                faqs_instructions.map((item, index) => {
                  return <Item data={item} key={index} />
                })
                : ''
            }
          </Accordion>
        </div>

        <div>
          <h3 className={classes.subtitleSection}>Seguridad de la cuenta</h3>
          <Accordion defaultActiveKey={1}>
            {
              faqs_security && faqs_security.length ?
                faqs_security.map((item, index) => {
                  return <Item data={item} key={index} />
                })
                : ''
            }
          </Accordion>
        </div> */}
        </div>

      </div >
      {
        !hide &&
        <Footer />
      }
      
    </>

  );
}

const mapStateToProps = (state) => {
  return {
    faqs_service: state.apiState.faqs_servicios,
    faqs_problems: state.apiState.faqs_problems,
    faqs_instructions: state.apiState.faqs_instructions,
    faqs_security: state.apiState.faqs_seguridad
  }
}

export default connect(
  mapStateToProps,
  {
    fetchFaqsServicios,
    fetchFaqsProblems,
    fetchFaqsInstructions,
    fetchFaqsSecurity
  }
)(SectionFqsGeneral);